import * as signalR from '@microsoft/signalr';
import { basePath } from './api';
import { IDeviceSubscriptionState } from './devices-states';

export enum MethodName {
  DeviceState = 'deviceStateNotification'
}
// eslint-disable-next-line consistent-return
const startConnection = (connection: signalR.HubConnection) => {
  try {
    return connection.start();
  } catch (err) {
    window.console.error(err);
    setTimeout(() => startConnection(connection), 5000);
  }
};

const waitForMessage = (
  methodName: string,
  token: string,
  onDataReceivedCallback: (data: any, connection: signalR.HubConnection) => void
) => {
  const reconnectionAttemptsTimeouts = [0, 2, 30, 60, 90, 120];
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${basePath}/realtimehub`, {
      accessTokenFactory: () => token.replace('Bearer ', ''),
      transport: 1
    })
    .withAutomaticReconnect(reconnectionAttemptsTimeouts)
    .build();

  connection.on(methodName, data => {
    if (onDataReceivedCallback) {
      onDataReceivedCallback(data, connection);
    }
  });

  connection.onreconnecting(err =>
    window.console.log('on reconnecting: ', err)
  );
  connection.onclose(err => window.console.log('on close: ', err));

  return new Promise(resolve => {
    startConnection(connection).then(() => resolve(connection));
  });
};

export const subscribeForDeviceStates = (
  locationId: string,
  token: string,
  onDataReceivedCallback: (data: IDeviceSubscriptionState) => void
) => {
  return new Promise(resolve => {
    waitForMessage(
      'deviceStateNotification',
      token,
      onDataReceivedCallback
    ).then(connection => {
      // @ts-ignore
      connection.invoke('SubscribeDeviceStatesForLocationAsync', locationId);
      resolve(connection);
    });
  });
};

export const unsubscribeForDeviceStates = (
  connection: signalR.HubConnection,
  locationId: string
) => {
  connection
    .invoke('UnsubscribeDeviceStatesForLocationAsync', locationId)
    .then(() => connection.stop());
};

export default {
  subscribeForDeviceStates,
  unsubscribeForDeviceStates
};
